/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/account_in'
export default icon
